module.exports = __webpack_public_path__ + "img/技术需求库banner.1c2c70fd.png";